import { Typography } from '@mui/material'
import noGraphSvg from '../images/no-data.svg'
import styles from './ReportGraph.module.scss'

export const NoGraph = () => {
    return (
        <div className={styles['graph-no-data-msg']}>
            <img src={noGraphSvg} alt='no data'/>
            <Typography variant='h4'>Data not available</Typography>
        </div>
    )
}